import { render, staticRenderFns } from "./RepriseTableLayout.vue?vue&type=template&id=48ce00aa"
import script from "./RepriseTableLayout.vue?vue&type=script&lang=js"
export * from "./RepriseTableLayout.vue?vue&type=script&lang=js"
import style0 from "./RepriseTableLayout.vue?vue&type=style&index=0&id=48ce00aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VRow,VSkeletonLoader})
